import React from 'react'
import { CustomModal } from '../../../../../components/common/CustomModal'
import { ReactSelectOption } from '../../../../../types'
import { Grid, Typography, Divider, Tooltip } from '@material-ui/core'
import { MigrationCollections, MigrationStatus } from '../../../../../types/migration'
import { MigrationChipStatus } from '../../MigrationChipStatus.tsx'
import { trimString } from '../../../../../utils/stringV2'
import { Title, ItemContainer, ShopLabel, StyledDivider } from '../styled'

interface CollectionDetailsModalProps {
  open: boolean
  onClose: () => void
  selectedShops?: ReactSelectOption[]
  collectionName?: MigrationCollections
  migrationRequestsMap?: Map<MigrationCollections, any[]>
  onRetry: (shop: ReactSelectOption, collectionName: MigrationCollections) => void
}

export const CollectionDetailsModal: React.FC<CollectionDetailsModalProps> = ({
  open,
  onClose,
  selectedShops,
  collectionName,
  migrationRequestsMap,
  onRetry,
}) => {
  const requests = collectionName ? migrationRequestsMap?.get(collectionName) : []
  const maxNameLength = 25

  const isCompanyLevel =
    collectionName === MigrationCollections.Brands ||
    collectionName === MigrationCollections.Vendors
  if (isCompanyLevel) {
    const latestRequest = requests?.[0]
    return (
      <CustomModal open={open} onClose={onClose} size="medium">
        <CustomModal.Header title={`${collectionName} Migration Details`} />
        <CustomModal.Content>
          <Grid style={{ maxHeight: 200, overflow: 'auto' }}>
            <div>
              <ItemContainer>
                <ShopLabel>{collectionName}</ShopLabel>
                <MigrationChipStatus
                  time={latestRequest?.created}
                  status={latestRequest?.status || MigrationStatus.NOT_SYNCED}
                  onRetry={() => {
                    if (collectionName && selectedShops?.[0]) {
                      onRetry(selectedShops[0], collectionName)
                    }
                  }}
                />
              </ItemContainer>
            </div>
          </Grid>
        </CustomModal.Content>
        <CustomModal.Footer cancelText="Close" onCancel={onClose} />
      </CustomModal>
    )
  }
  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <CustomModal.Header title={`${collectionName} Migration Details`} />
      <CustomModal.Content>
        <Grid style={{ maxHeight: 200, overflow: 'auto' }}>
          <div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '10px',
              }}
            >
              <Title>Shops</Title>
            </div>
            {selectedShops?.map((shop) => {
              const shopRequests = requests?.filter((request) => {
                const requestShopIds = request.shopId.split(',')
                return requestShopIds.includes(shop.value)
              })
              const latestRequest = shopRequests?.[0]
              const shouldTruncateName = shop.label.length > maxNameLength
              return (
                <React.Fragment key={shop.value}>
                  <ItemContainer>
                    {shouldTruncateName ? (
                      <Tooltip
                        title={<Typography style={{ color: 'white' }}>{shop.label}</Typography>}
                        placement="top"
                      >
                        <ShopLabel>{trimString(shop.label, maxNameLength)}</ShopLabel>
                      </Tooltip>
                    ) : (
                      <ShopLabel>{shop.label}</ShopLabel>
                    )}
                    <MigrationChipStatus
                      time={latestRequest?.created}
                      status={latestRequest?.status || MigrationStatus.NOT_SYNCED}
                      onRetry={() => {
                        if (collectionName) {
                          onRetry(shop, collectionName)
                        }
                      }}
                    />
                  </ItemContainer>
                  <StyledDivider />
                </React.Fragment>
              )
            })}
          </div>
        </Grid>
      </CustomModal.Content>
      <CustomModal.Footer cancelText="Close" onCancel={onClose} />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/CollectionDetailsModal/index.tsx